// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ConfirmEntryReportInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/confirm_entry_report
 *
 * Confirm an entry report (requires 5 photos).
 *
 * Fields:
 *   order_item_id — int, required (so_order_items PK)
 *   attributes    — Orders_OrderItemAttributeInputRow[], optional
 *                   (saved via So_order_item_attribute_values_model::replaceForOrderItem
 *                   before the photo-count gate runs)
 */
import type { Orders_OrderItemAttributeInputRow } from './Orders_OrderItemAttributeInputRow'
import { registerContract } from './validate'

export interface Orders_ConfirmEntryReportInput {
order_item_id: number
attributes?: Orders_OrderItemAttributeInputRow[]
}

registerContract('Orders_ConfirmEntryReportInput', {
  order_item_id: { type: 'number',  required: true },
  attributes: {
    type: 'array',
    required: false,
    items: {
      attribute_id: { type: 'number',  required: true },
      value:        { type: 'string',  required: false },
    },
  },
})
